import { tokens, type GriffelStyle } from "@fluentui/react-components";

/**
 * 웰 안쪽 최소 좌우 여백.
 * 읽는 컬럼의 스크롤 부모와 표·목록이 이 값만 쓴다. 정의는 styles/globals.css.
 */
export const shellGutter = "var(--shell-gutter, 24px)";

/** 읽는 화면의 내용 폭. 좌우 패딩은 스크롤 부모에 있다. */
export const contentColumnMax = "1180px";

/**
 * 컬럼 폭으로 칸을 내린다.
 * Griffel은 컨테이너 쿼리를 문자열로 정렬하므로, 단계가 둘이면 같은 자릿수의 min-width를 쓴다.
 * 넓은 조건이 나중에 와서 좁은 조건을 덮는다.
 */
export const pageStackAt = "720px";
export const pagePairAt = "960px";
export const pageNarrowAt = "560px";

export function pageMax(width: string): string {
  return `@container page (max-width: ${width})`;
}

export function pageMin(width: string): string {
  return `@container page (min-width: ${width})`;
}

/** 스크롤은 웰 폭. 컬럼은 그 안에 둔다. */
export const contentScroll: GriffelStyle = {
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "0%",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  paddingTop: tokens.spacingVerticalL,
  paddingBottom: tokens.spacingVerticalXXL,
  paddingLeft: shellGutter,
  paddingRight: shellGutter,
  boxSizing: "border-box",
};

/**
 * 필터 줄 바로 아래 본문.
 * 줄은 44px이고 컨트롤 위·아래가 8px이다. 본문 위를 0으로 두면 내용도 같은 8px에서 시작한다.
 */
export const filterScroll: GriffelStyle = {
  ...contentScroll,
  paddingTop: 0,
};

/**
 * 툴바 아래 목록 본문.
 * 높이는 화면에서 툴바를 뺀 나머지다. 자식이 GhostEmptyState 하나면 그 높이의 세로 가운데에 온다.
 */
export const listBody: GriffelStyle = {
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "0%",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  boxSizing: "border-box",
};

/** 빈 상태와 그 다음 동작을 남은 높이의 세로 가운데에 둔다. */
export const centerFill: GriffelStyle = {
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "0%",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
};

/**
 * 크롬 아래 화면 껍질.
 * 일정·캘린더를 뺀 콘텐츠가 웰 너비로 늘어나지 않게 한다.
 * 좌우 거터는 화면 안 패딩이라, 내용 폭은 contentColumnMax다.
 */
export const contentShell: GriffelStyle = {
  width: "100%",
  maxWidth: `calc(${contentColumnMax} + 2 * ${shellGutter})`,
  marginLeft: "auto",
  marginRight: "auto",
  alignSelf: "center",
  boxSizing: "border-box",
  minWidth: 0,
};

/** 제목과 본문이 같이 쓰는 읽는 컬럼. 최대 폭·컨테이너 쿼리만 가진다. */
export const contentColumn: GriffelStyle = {
  width: "100%",
  maxWidth: contentColumnMax,
  marginLeft: "auto",
  marginRight: "auto",
  display: "flex",
  flexDirection: "column",
  gap: tokens.spacingVerticalM,
  minWidth: 0,
  flexGrow: 1,
  flexShrink: 0,
  containerType: "inline-size",
  containerName: "page",
};
